import { getIn } from 'icepick';
import { SURVEY_TYPE } from 'event-widgets/utils/questionConstants';

/**
 * Returns survey type from config object
 * @param {Object} config
 * @returns {string}
 */
export function getQuestionSurveyType(config) {
  return getIn(config, ['appData', 'question', 'additionalInfo', 'surveyType']);
}

/**
 * Returns Field name for product and travel questions
 * @param {Object} props
 * @returns {string}
 */
export function getQuestionFieldName(props) {
  if (isTravelQuestion(getQuestionSurveyType(props.config))) {
    return props.config.id + (props.booking.id ? '-' + props.booking.id : '');
  }
  return props.config.id + (props.eventRegistrationId ? '-' + props.eventRegistrationId : '');
}

/**
 * Returns true if survery type belongs to travel questions
 * @param {string} surveyType
 * @returns {boolean}
 */
export function isTravelQuestion(surveyType) {
  return [
    SURVEY_TYPE.AIR_ACTUAL_QUESTIONS, SURVEY_TYPE.AIR_ACTUAL_ALTERNATE_QUESTIONS,
    SURVEY_TYPE.AIR_QUESTIONS, SURVEY_TYPE.AIR_ALTERNATE_QUESTIONS,
    SURVEY_TYPE.HOTEL_QUESTIONS, SURVEY_TYPE.HOTEL_ALTERNATE_QUESTIONS
  ].includes(surveyType);
}

/**
 * Returns true if survery type belongs to travel alternate questions
 * @param {string} surveyType
 * @returns {boolean}
 */
export function isAlternateQuestion(surveyType) {
  return [
    SURVEY_TYPE.AIR_ACTUAL_ALTERNATE_QUESTIONS,
    SURVEY_TYPE.AIR_ALTERNATE_QUESTIONS,
    SURVEY_TYPE.HOTEL_ALTERNATE_QUESTIONS
  ].includes(surveyType);
}
